// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__CuQkP","navlink":"Navigation_navlink__2VIye","navlinks":"Navigation_navlinks__1d9yK"};